export const TOOLBAR_IMAGE_BUTTON_CONSTS = {
  pastePhotoMsg: 'Вставить фото',
  pasteGalleryMsg: 'Вставить галерею'
}
